import { Index } from '../features/practice/Index';
import { THEMES } from '../constants/Consts';

interface PracticeProps {
  themeType: THEMES;
}

export const Practice = ({ themeType }: PracticeProps) => {
  return <Index themeType={themeType} />;
};
